<template>
    <div class="dropdown filter_item">
        <button class="btn m-r-5 btn-default waves-effect waves-light dropdown-toggle" :class="{'btn-success': price_touched}" type="button" data-toggle="dropdown">
            Valor do Aluguel
        </button>
        <div class="dropdown-menu dropdown-menu-right arrow-dropdown-menu arrow-menu-right dropdown-lg">
            <p class="h5 m-b-15">Valor do Aluguel</p>

            <div class="form-group">
                <input type="text" name="preco" class="price_picker" />
            </div>

            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ionRangeSlider from '../../../../../../legacy/node_modules/ion-rangeslider';
export default {
    data() {
        return {
            price_range: this.$store.getters.getFilter.price_range || [0, 15000],
            selector: null,
        }
    },
    watch: {
        selected_price_range: {
            handler(newVal) {
                this.price_range = newVal;
                this.selector.update({
                    from: this.price_range[0],
                    to: this.price_range[1],
                });
            },
        }
    },
    computed: {
        selected_price_range() {
            return this.$store.getters.getFilter.price_range || [0, 15000];
        },
        price_touched() {
            return this.selected_price_range[0] != 0 || this.selected_price_range[1] != 15000;
        },
    },
    methods: {
        filter() {
            this.$store.commit('setFilter', {price_range: this.price_range});
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    },
    mounted() {
        this.selector = $(".price_picker").ionRangeSlider({
            type: "double",
            skin: 'modern',
            grid: true,
            min: 0,
            max: 15000,
            step: 50,
            from: this.price_range[0],
            to: this.price_range[1],
            prefix: "R$ ",
            onFinish: (data) => {
                this.price_range = [data.from, data.to];
            }
        }).data('ionRangeSlider');
    }
}
</script>